module.exports = "/_next/static/images/AutomaticallyMeasure@2x-3be6b746974f55e43a6c2e2a1e7c5d24.webp";